import { setIsActiveSpinner } from "../../Redux/GeneralSlice";
import StripeService from "../../Services/http/StripeService";

const getAllPaymentMethods = async (dispatch, userId) => {
    dispatch(setIsActiveSpinner(true));
    const response = await StripeService.getPaymentMethods(userId);
    dispatch(setIsActiveSpinner(false));
    return response;
};

const getClientSecret = async (payment_method_type, userId) => {
    const response = await StripeService.getClientSecret(payment_method_type, userId);
    return response;
};

const createCustomer = async (userId) => {
    const response = await StripeService.createCustomer(userId);
    return response;
};

const acceptingFuturePayments = async (paymentMethodId, userId) => {
    const response = await StripeService.acceptingFuturePayments(paymentMethodId, userId);
    return response;
};

const updatePaymentMethodToDefault = async (dispatch, paymentMethodId, userId) => {
    dispatch(setIsActiveSpinner(true));
    try {
        return new Promise((resolve, reject) => {
          StripeService.updatePaymentMethodToDefault(paymentMethodId, userId).then(
            (data) => {
            dispatch(setIsActiveSpinner(false));
              if (data.success) {
                resolve(true);
              } else {
                alert("An error occurred updating a payment method to default");
                resolve(null);
              }
            });
        })
      } catch (error) {
        dispatch(setIsActiveSpinner(false));
        console.log('Error updatePaymentMethodToDefault:', error);
        return null;
      }
}

const StripeUtils = {
    getAllPaymentMethods,
    getClientSecret,
    createCustomer,
    updatePaymentMethodToDefault,
    acceptingFuturePayments
};

export default StripeUtils;